import { useEffect, useState } from "react";

/** Dieselbe Grenze wie im CSS: darunter ist immer genau eine Spalte sichtbar. */
export const SCHMAL = "(max-width: 900px)";

export function istSchmal(): boolean {
  return typeof window !== "undefined" && window.matchMedia(SCHMAL).matches;
}

/** Reagiert auf Drehen des Telefons und Ändern der Fensterbreite. */
export function useSchmal(): boolean {
  const [schmal, setSchmal] = useState(istSchmal);
  useEffect(() => {
    const mq = window.matchMedia(SCHMAL);
    const onChange = () => setSchmal(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return schmal;
}

/** Kurzes Antippen spürbar machen — nur Android kann das, iOS ignoriert es still. */
export function haptik(ms = 10): void {
  try { navigator.vibrate?.(ms); } catch { /* nicht unterstützt */ }
}

/** Initialen für Avatare: „Petra Vogt" → „PV", „info@firma.de" → „I". */
export function initialen(name: string): string {
  const teile = name.replace(/[<>"@].*$/, "").trim().split(/\s+/).filter(Boolean);
  if (teile.length === 0) return (name[0] ?? "?").toUpperCase();
  return ((teile[0]![0] ?? "") + (teile.length > 1 ? teile[teile.length - 1]![0] ?? "" : "")).toUpperCase();
}

/** Gleicher Absender, gleiche Farbe — ohne dass jemand Farben pflegen muss. */
export function avatarFarbe(schluessel: string): string {
  let h = 0;
  for (let i = 0; i < schluessel.length; i++) h = (h * 31 + schluessel.charCodeAt(i)) >>> 0;
  return `hsl(${h % 360} 55% 52%)`;
}
